import React, { useState, useRef, useEffect } from "react";
import ResponsiveDrawer from "./drawer";
import { Card, CardContent, Typography, CircularProgress, Button, TextField, CardActions, Divider, IconButton, Modal, Backdrop, Fade  } from "@mui/material";
import axios from "axios";
import { useAuth } from "./firebase/AuthContext";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import ZoomOutIcon from '@mui/icons-material/ZoomOut';
import { firestore } from "./firebase/firebase";
import 'firebase/compat/firestore';
import { collection, query, orderBy, deleteDoc, updateDoc, addDoc, getDocs, doc } from "@firebase/firestore";
//import LoggedIn from "./loggedIn"
import { Tree, TreeNode } from 'react-organizational-chart';
import { useMediaQuery } from '@material-ui/core';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import QuizIcon from '@mui/icons-material/Quiz';
import BookmarkAddIcon from '@mui/icons-material/BookmarkAdd';
import DeleteIcon from '@mui/icons-material/Delete';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import PlansScreen from "./paymentDrawer";
import CloseIcon from '@mui/icons-material/Close';

import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';

import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "white", // add white background color
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    textAlign: "center",
  },
  rounded: {
    borderRadius: "10px",
    border: "none",
  },
}));



const Workspace =  () => {

  const everyRef = collection(firestore, 'everyonesProjects');
  const queryRef = query(everyRef, orderBy("projectName", "desc"));
  const history = useHistory();

const [projectDelete, setProjectDelete] = useState();

  const [selectedDescriptions, setSelectedDescriptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState([]);
  const [suggestionNode, setSuggestionNode] = useState();
  const [treeNodes, setTreeNodes] = useState([
    { id: 1, parentId: null, /*data: "Node 1",*/colour: 'black', description: "" },
  ]);
  const [zoom, setZoom] = useState(1);
  const zoomIntervalRef = useRef(null);

  const [projects, setProjects] = useState([]);
  const [choice, setChoice] = useState(null);

  const [isDragging, setIsDragging] = useState(false);

  const { currentUser } = useAuth();
 //const everyRef = collection(firestore, 'everyonesProjects');
  const nameRef = useRef();
  const [scale, setScale] = useState(1);
        const [translate, setTranslate] = useState({ x: 0, y: 0 });
        const [initialTranslate, setInitialTranslate] = useState({ x: 0, y: 0 });
        const containerRef = useRef(null);
        
        const childRef = useRef(null);

        const [handleZoomInActive, setHandleZoomInActive] = useState(false);
  const [handleZoomOutActive, setHandleZoomOutActive] = useState(false);
  const [handleMenuActive, setHandleMenuActive] = useState(false);

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [openPayment, setOpenPayment] = useState(false);

  const [subscription, setSubscription] = useState(null);


  const [projectGet, setProjectGet] = useState(false);
  const isMobile = useMediaQuery('(max-width: 600px)');

  const handleResetClick = (event) => {
    setTranslate({ x: 0, y: 0 });
    setTranslateMobile({ x: 0, y: 0 })
    
  };


  
  
  const getSubscriptions = async () => {
    try {
      const subscriptionsRef = firestore
        .collection("customers")
        .doc(currentUser.uid)
        .collection("subscriptions");
  
      const querySnapshot = await subscriptionsRef.get();
  
      const lastSubscription = querySnapshot.docs.pop();
  
      return [
        {
          id: lastSubscription.id,
          suggestions: lastSubscription.data().items[0].price.product.metadata.Suggestions,
          summaries: lastSubscription.data().items[0].price.product.metadata.Summaries,
          status: lastSubscription.data().status,
          endedAt: lastSubscription.data().ended_at,
        }
      ];
    } catch (error) {
      console.error("Error getting subscriptions: ", error);
      return [];
    }
  };
  
  
  useEffect(() => {
    let isMounted = true;
  
    getSubscriptions().then((subscriptions) => {
      if (isMounted) {
        setSubscription(subscriptions);
      }
    });
  
    return () => {
      isMounted = false;
    };
  }, []);


  const handleSuggestionClick = async (nodeId, description) => {
    setSuggestionNode(nodeId);
    setResponseData([]);
    const subscriptions = await getSubscriptions();

    console.log(subscriptions)

    if (!description){
      return null;
    }
  
    if (!subscriptions[0] || subscriptions[0].status === "canceled") {

      return setOpenPayment(true);
    }
  
    try {
      setLoading(true);
  
      const response = await axios.post(
        `${process.env.REACT_APP_PORTAL}/aisuggestions`,
        {
          suggestion: `${description}`,
        }
      );
  
      const responseString = response.data.choices[0].text;
      const suggestionsArray = responseString.split("\n");
      setResponseData(suggestionsArray);
  
      const subscriptionDocRef = firestore
        .collection("customers")
        .doc(currentUser.uid)
        .collection("subscriptions")
        .doc(subscriptions[0].id);
  
      const currentSuggestions = parseInt(subscriptions[0].suggestions);
      const updatedSuggestions = currentSuggestions - 1;
  
      await subscriptionDocRef.update({
        "items.0.price.product.metadata": {
          Suggestions: updatedSuggestions.toString(),
          Summaries: subscriptions[0].summaries,
        },
      });
  
      console.log("Subscription updated successfully!");

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
     // console.log(subscriptions[0]);
    }
  };
  
  
  /*const handleSuggestionClick = async (nodeId, description) => {
    console.log(subscription)

    setSuggestionNode(nodeId);
    setResponseData([]);

  
    if (!description) {
      return null;
    }
  
    if (!subscription?.id) {
      return setOpenPayment(true)
    }
  
    if (subscription?.status == 'canceled') {
      return setOpenPayment(true)
    }
  
    try {
      setLoading(true);
      
      
      const response = await axios.post(`${process.env.REACT_APP_PORTAL}/aisuggestions`, {
        suggestion: `${description}`,
      });
  
  
      const responseString = response.data.choices[0].text;
      const suggestionsArray = responseString.split("\n");
      setResponseData(suggestionsArray);
  
      // Update the summaries field in Firebase
      const currentSuggestions = parseInt(subscription.suggestions);
  
      const updatedSuggestions = currentSuggestions - 1;      
  
      const subscriptionDocRef = firestore
        .collection("customers")
        .doc(currentUser.uid)
        .collection("subscriptions")
        .doc(subscription.id);
  
        await subscriptionDocRef.update({
          "items.0.price.product.metadata": {
            Suggestions: updatedSuggestions.toString(),
            Summaries: subscription.summaries,
            // ... add more fields as needed
          }
        }).then(() => {

        
        
    
        
        console.log("Subscription updated successfully!");
      })
      .catch((error) => {
        console.error("Error updating subscription:", error);
      });
  
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
      console.log(subscription);

    }
  };*/




  //delete modal
  const handleOpen = () => {

    if(currentUser){
      setOpen(true);
    }else{
      history.push("/workspace")
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDelete = async () => {
    try {
      await deleteDoc(doc(everyRef, projectDelete));
      getProjects();
      console.log(`Project with ID ${projectDelete} deleted successfully.`);
    } catch (error) {
      console.error("Error deleting project:", error);
    } finally {
      handleClose()
    }
  };

  const deleteModal = () => {

    return (
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
            style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          }}
        >
          <Fade in={open}>
          <div style={{ display: "flex", justifyContent: "space-between", margin: '10px' }}>
            <div className={`${classes.paper} ${classes.rounded}`}>
            
              <h1>Are you sure you want to delete this project?</h1>
              <Button onClick={()=>handleDelete()} style={{ backgroundColor: '#7E3AF2', color: 'white', fontFamily: 'Inter', marginRight: '10px'}}>Yes</Button>
              <Button onClick={()=>handleClose()} style={{ color: 'grey', fontFamily: 'Inter', marginLeft: '10px' }}>Cancel</Button>
            </div>
            </div>
          </Fade>
        </Modal>
      </div>
    );
  };
  

  //handle payment modal

  const handlePaymentClose = () => {
    setOpenPayment(false);
  };


  const paymentModal = () => {

    return (
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          className={classes.modal}
          open={openPayment}
          onClose={handlePaymentClose}
          closeAfterTransition
          BackdropProps={{
            timeout: 500,
            style: { backgroundColor: "rgba(0, 0, 0, 0.5)" },
          }}
        >
          <Fade in={openPayment}>
          <div style={{ display: "flex", justifyContent: "space-between", margin: '10px' }}>
            <div className={`${classes.paper} ${classes.rounded}`}>
              <h1>Opps, looks like you need to upgrade to use our AI features!</h1>
              <center>
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <PlansScreen /*sub={handleSummariesChange}*/ />
    <Button onClick={()=>handlePaymentClose()} style={{ color: 'grey', fontFamily: 'Inter', marginLeft: '10px' }}>Cancel</Button>
  </div>
</center>

            </div>
            </div>
          </Fade>
        </Modal>
      </div>
    );
  };


  //functions for the project boards
  
  const getProjects = async () => {

    setProjectGet(true)
    try {
      const data = await getDocs(queryRef);
      const filteredProjects = data.docs
        .filter(doc => doc.data().email === currentUser.email)
        .map(doc => ({ ...doc.data(), id: doc.id }));
      setProjects(filteredProjects);
    } catch (error) {
      console.error(error);
    }
    setProjectGet(false)

  };
  
  useEffect(() => {
    getProjects(); 
  }, []);


  const saveArray = async (projectArray) => {
      try {
        const docRef = doc(everyRef, choice.id);
        await updateDoc(docRef, {
          nodes: projectArray
        });
        getProjects();
        console.log("Project array saved successfully");
        toast.success("Project has been saved!", {
          position: toast.POSITION.TOP_CENTER
      })
      } catch (error) {
        console.error("Error saving project array ", error);
        toast.error("Opps, something went wrong!", {
          position: toast.POSITION.TOP_CENTER
      })

      }
    };

    function getUniqueNumber() {
      return Date.now();
    }

    
  
        const handleClick = async (event) => {
          event.preventDefault();

      await addDoc(everyRef, {
        projectName: nameRef.current.value,
        email: currentUser.email,
        nodes: [
          { id: getUniqueNumber(), parentId: null, /*data: "Node 1",*/ colour: 'black', description: "" },
      ]
      });

      getProjects(); 


      
    };

    const chosen = (project) => {

      setChoice(project)
      setTreeNodes(project.nodes)
      //console.log(project)

    };


  //allow drag in mobile

  const [scaleMobile, setScaleMobile] = useState(1);
  const [translateMobile, setTranslateMobile] = useState({ x: 0, y: 0 });
  const lastPositionMobile = useRef(null);

  function handleTouchStartMobile(event) {
    event.preventDefault();
    lastPositionMobile.current = {
      x: event.touches[0].clientX,
      y: event.touches[0].clientY,
    };
  }

  function handleTouchMoveMobile(event) {
    event.preventDefault();
    if (lastPositionMobile.current) {
      const deltaX = event.touches[0].clientX - lastPositionMobile.current.x;
      const deltaY = event.touches[0].clientY - lastPositionMobile.current.y;
      setTranslateMobile({
        x: translateMobile.x + deltaX / scaleMobile,
        y: translateMobile.y + deltaY / scaleMobile,
      });
      lastPositionMobile.current = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY,
      };
    }
  }

  function handleTouchEndMobile() {
    lastPositionMobile.current = null;
  }

  function handleWheelMobile(event) {
   // event.preventDefault();
    const newScale = scaleMobile * (1 - event.deltaY / 1000);
    setScaleMobile(newScale);
  }


    //drag function in desktop

    const handleMouseDown = (e) => {
      setIsDragging(true);
      setInitialTranslate({ x: e.clientX - translate.x, y: e.clientY - translate.y });
    };
    
    const handleMouseMove = (e) => {
      if (isDragging) {
        setTranslate({ x: e.clientX - initialTranslate.x, y: e.clientY - initialTranslate.y });
      }
    };
    
    const handleMouseUp = (e) => {
      setIsDragging(false);
    };
    
    
    
    useEffect(() => {
      const child = childRef.current;
      if (child) {
        child.style.transform = `scale(${scale}) translate(${translate.x}px, ${translate.y}px)`;
      }
    }, [scale, translate]);


  //zoom function

  function handleZoomInStart() {
    zoomIntervalRef.current = setInterval(() => {
      setHandleZoomInActive(true);
      setZoom(zoom => zoom + 0.1);
    }, 50);
  }

  function handleZoomOutStart() {
    zoomIntervalRef.current = setInterval(() => {
      setHandleZoomOutActive(true);
      setZoom(zoom => Math.max(zoom - 0.1, 0.1));
    }, 50);
  }

  function handleZoomStop() {
    clearInterval(zoomIntervalRef.current);
    setHandleZoomInActive(false);
    setHandleZoomOutActive(false);
  };

  function menuActiveStart() {
    setHandleMenuActive(true);
  }
  function menuActiveStop() {
    setHandleMenuActive(false);
  }

  const addNode = (parentId, colour) => {

  const newNode = {
    id: getUniqueNumber(),
    parentId,
    //data: `Node ${parentId}.${treeNodes.filter((n) => n.parentId === parentId).length + 1}`,
    description: "",
    colour: colour
  };
  setTreeNodes([...treeNodes, newNode]);

};

  const addNodeWithDescription = (parentId, word, colour) => {
    const newNode = {
      id: getUniqueNumber(), //treeNodes.length + 1,
      parentId,
      //data: `Node ${parentId}.${treeNodes.filter((n) => n.parentId === parentId).length + 1}`,
      description: `${word}`,
      colour: `${colour}`
    };
    setTreeNodes([...treeNodes, newNode]);
    setResponseData([]);
  };

  const removeNode = (id) => {
    setTreeNodes(treeNodes.filter((n) => n.id !== id && n.parentId !== id));
  };

  const handleDescriptionChange = (id, event) => {
    setTreeNodes((prevTreeNodes) =>
      prevTreeNodes.map((node) => {
        if (node.id === id) {
          return { ...node, description: event.target.value };
        }
        return node;
      })
    );
  };

  const handleCardClick = (description) => {
    if (!description) {
      return;
    }
    
    setSelectedDescriptions([...selectedDescriptions, description]);
  };


  


  const handleBgColorChange = (id, event) => {
    // update nodes with new colour
    setTreeNodes((prevNodes) => {
      const newNodes = prevNodes.map((node) => {
        if (node.id === id) {
          return { ...node, colour: event.target.value };
        }
        return node;
      });
      return newNodes;
    });
  
    // recursively update children
    /*const childNodes = treeNodes.filter((node) => node.parentId === id);
    childNodes.forEach((childNode) => {
      handleBgColorChange(childNode.id, event);
    });*/
  };
  



  //the rendering functions./////
        
      
  const renderNode = nodeData => (
    <>
    <center style={{paddingLeft: "20px", paddingTop: "40px", paddingRight: "20px"}}>
    <TextField
  placeholder="Edit here..."
  value={nodeData.description}
  onChange={(event) => handleDescriptionChange(nodeData.id, event)}
  multiline
  sx={{
    "& fieldset": {
      border: "none",
    }
  }}
  InputProps={{
    style: {
      width: "400px",
      fontFamily: "inter",
      fontStyle: "normal",
      fontWeight: 700,
      fontSize: "20px",
      color: `${nodeData.colour}`
    }
  }}
/>
<br/>
          <Divider style={{backgroundColor: `${nodeData.colour}`, width: "430px"}} />
        <br/>
    <Card style={{maxWidth:'400px'}}>
      <CardContent>
        
        <Button onClick={() => addNode(nodeData.id, nodeData.colour)}>
          <AddIcon style={{color: `${nodeData.colour}`}}/>
        </Button>
        {nodeData.id !== 1 && (
          <Button onClick={() => removeNode(nodeData.id)}>
            <RemoveIcon style={{color: `${nodeData.colour}`}}/>
          </Button>
        )}
        <Button
                      onClick={() => handleCardClick(nodeData.description)}
                    >
                      <BookmarkAddIcon style={{color: `${nodeData.colour}`}}/>
                    </Button>
                    <Button
                      onClick={() => handleSuggestionClick(nodeData.id, nodeData.description)}
                    >
                      <QuizIcon style={{color: `${nodeData.colour}`}}/>
                    </Button>
        <select // Add select element for background color
              style={{ margin: "0 10px", padding: "5px", borderRadius: "5px", border: "none", cursor: "pointer", fontFamily: 'inter', color: `${nodeData.colour}` }}
              
              value={nodeData.colour}
              onChange={(event) => handleBgColorChange(nodeData.id, event)}
              >
              <option value="black">Black</option>
              <option value="#FF0000">Red</option>
              <option value="#1BA539">Green</option>
              <option value="#0500FF">Blue</option>
            </select>
            

        {(nodeData.id === suggestionNode) && (
              <>
        {loading ? (
          <div style={{ padding: '100px' }}>
            <CircularProgress style={{color: `${nodeData.colour}`}}/>
          </div>
        ) : (
          <div>
              <>
              {responseData.map((word, index) => {
  if (typeof word === "string" && word.match(/[a-zA-Z]+/)) {
    return (
      <Card
        key={index}
        style={{
          width: "340px",
          padding: "10px",
          margin: "10px 0",
          border: "1px solid lightgray",
          borderRadius: "5px"
        }}
        onClick={() => addNodeWithDescription(nodeData.id, word, nodeData.colour)}
      >
        <CardContent>
          <Typography
            style={{
              margin: "0 10px",
              padding: "5px",
              borderRadius: "5px",
              border: "none",
              cursor: "pointer",
              fontFamily: 'inter',
              color: `${nodeData.colour}`
            }}
          >
            {word}
          </Typography>
        </CardContent>
      </Card>
    );
  } else {
    return null;
  }
})}

                {responseData.length > 1 && (
        <Button style={{color: 'white', backgroundColor:`${nodeData.colour}`}} onClick={() => setResponseData([])}>cancel</Button>
      )}
              </>
          </div>
        )}
        </>
              )}
      </CardContent>
    </Card>
    </center>
    </>
  );

  const renderTree = parentId => {
    const children = treeNodes.filter(node => node.parentId === parentId);

    return children.map(child => (
      <TreeNode key={child.id} label={renderNode(child)} >
        {renderTree(child.id)}
      </TreeNode>
    ));
  };


 





        const loggedIn = () => {

            if(choice === null){

                return (
                  <>
                  {deleteModal()}
                  <ResponsiveDrawer selections={selectedDescriptions} />
                  <div style={{ display: "flex", flexDirection: "column", backgroundColor: '#F5F5F5', height: '100vh' }}>
                    <div style={{ position: "sticky", top: 0, zIndex: 1, backgroundColor: '#F5F5F5' }}>
                      <h3 align="center" style={{ margin: "20px 0", fontWeight: "bold" }}>
                        Workspace
                      </h3>
                      <center >
                        <form onSubmit={handleClick}>
                          <TextField
                            id="New project"
                            label="New project"
                            variant="outlined"
                            style={{ margin: "16px 0", width: "25ch", backgroundColor:'white' }}
                            inputRef={nameRef}
                            required
                          />
                          <br />
                          <button
                            type="submit"
                            style={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 'bold', backgroundColor: '#7E3AF2', color: '#FFFFFF', margin: '5px',padding: '16px 32px', borderRadius: '8px', border: 'none', cursor: 'pointer' }}
                          >
                            Add Document
                          </button>
                        </form>
                        <br/>

                      </center>
                    </div>
                    <div style={{ height: "100%", overflow: "scroll", backgroundColor: '#F5F5F5' }}>
                      <center>
                      

    {projectGet ? (<CircularProgress
        size={24}
        style={{ color:'black',fontFamily: 'Inter', marginLeft: '10px' }}
      />):projects.map((project) => (
        <div key={project.id}>
          <Card
            style={{
              width: "250px",
              padding: "10px",
              margin: "10px",
              border: "1px solid lightgray",
              borderRadius: "5px",
            }}
            onClick={() => chosen(project)}
          >
            <CardContent>
              <center>
                <h3 style={{ fontFamily: "Inter" }}>{project.projectName}</h3>
                <IconButton
                  aria-label="delete"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpen();
                    setProjectDelete(project.id);
                  }}
                >
                  <DeleteIcon />
                </IconButton>
              </center>
            </CardContent>
          </Card>
        </div>
      ))}
                      
                      </center>
                    </div>
                  </div>
                </>  
                
                  );
                  
    
            } else {

          return (
            <div style={{ display: "flex", backgroundColor: "#F5F5F5"}}>
              <div style={{
                overflow: "auto",
                height: "100%",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}>
                <div style={{ position: 'absolute', top: '3%', right: '3%', zIndex: '1' }}>
                <div>
    {isMobile ? (<div style={{ display: "flex", backgroundColor: "#F5F5F5"}}>
  <div style={{
    overflow: "auto",
    height: "100%",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  }}>
    <div style={{ position: 'absolute', top: '3%', right: '3%', zIndex: '1' }}>
      <Card style={{ border: '1px solid lightgray', borderRadius: '5px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <CardActions style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          <div style={{ marginBottom: '10px' }}>
            <Button onClick={() => setChoice(null)} style={{ color: '#7E3AF2' }}>
              <ArrowBackIcon />
            </Button>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <Button onClick={() => saveArray(treeNodes)} style={{ color: '#7E3AF2' }}>
              <SaveIcon />
            </Button>
          </div>
          <div style={{ marginBottom: '10px' }}>
            <Button onClick={() => handleResetClick()} style={{ color: '#7E3AF2' }}>
              <CenterFocusWeakIcon />
            </Button>
          </div>
          <div style={{ marginTop: '10px' }}>
            <Button
              onMouseDown={handleZoomInStart}
              onTouchStart={handleZoomInStart}
              onMouseUp={handleZoomStop}
              onTouchEnd={handleZoomStop}
              onTouchCancel={handleZoomStop}
              style={{ color: '#7E3AF2' }}
            >
              <ZoomInIcon />
            </Button>
          </div>
          <div style={{ marginTop: '10px' }}>
            <Button
              onMouseDown={handleZoomOutStart}
              onTouchStart={handleZoomOutStart}
              onMouseUp={handleZoomStop}
              onTouchEnd={handleZoomStop}
              onTouchCancel={handleZoomStop}
              style={{ color: '#7E3AF2' }}
            >
              <ZoomOutIcon />
            </Button>
          </div>
          <div style={{ marginTop: '10px' }}>
            <Button onMouseDown={menuActiveStart} onMouseUp={menuActiveStop} style={{ color: '#7E3AF2' }}>
              <ResponsiveDrawer selections={selectedDescriptions} />
            </Button>
          </div>
        </CardActions>
      </Card>
    </div>
  </div>
</div>
) : (
      <div>
        <Card style={{
        border: '1px solid lightgray',
        borderRadius: '5px',
      }}>
        <CardActions>
        <Button onClick={() => setChoice(null)} style={{color:'#7E3AF2'}}><ArrowBackIcon/></Button>
          <Button onClick={() => saveArray(treeNodes)} style={{color:'#7E3AF2'}}><SaveIcon/></Button>
          <Button onClick={() => handleResetClick()} style={{color:'#7E3AF2'}}><CenterFocusWeakIcon/></Button>

          <Button
        onMouseDown={handleZoomInStart}
        onTouchStart={handleZoomInStart}
        onMouseUp={handleZoomStop}
        onTouchEnd={handleZoomStop}
        onTouchCancel={handleZoomStop}
        style={{color:'#7E3AF2'}}
      >
        <ZoomInIcon />
      </Button>
      <Button
        onMouseDown={handleZoomOutStart}
        onTouchStart={handleZoomOutStart}
        onMouseUp={handleZoomStop}
        onTouchEnd={handleZoomStop}
        onTouchCancel={handleZoomStop}
        style={{color:'#7E3AF2'}}
      >
        <ZoomOutIcon />
      </Button>
          
        </CardActions>

        <ResponsiveDrawer selections={selectedDescriptions} />
      </Card>
      </div>
    )}
  </div>
                </div>
                <div id="orgChartContainer" style={{ display: "flex", justifyContent: "center" }}>
                  <div id="orgChart" style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                        <div style={{ position: 'relative' }}>
                           {/*the below functions allow drag in desktop*/}
                          <div
                            ref={containerRef}
                            onMouseDown={handleMouseDown}
                            onMouseMove={handleMouseMove}
                            onMouseUp={handleMouseUp}
                            
                          >
                            <div ref={childRef} style={{ transformOrigin: 'center' }}>
                              {/*the below functions allow navigation/drag in mobile*/}
                            <div
      onTouchStart={handleTouchStartMobile}
      onTouchMove={handleTouchMoveMobile}
      onTouchEnd={handleTouchEndMobile}
      //This on wheel allows for the scroll zoom/pinch zoom.
      onWheel={handleWheelMobile}
      style={{
        touchAction: 'none',
        transform: `translate(${translateMobile.x}px, ${translateMobile.y}px) scale(${scaleMobile})`,
        width: '100%',
        height: '100%',       
      }}
    >                      <div style={{ transform: `scale(${zoom})`, transformOrigin: 'center' }}>

                              <center>
                                <h1 style={{fontFamily: 'inter'}}>{choice.projectName}</h1>
                              </center>
                              <Tree
                                lineWidth={'1px'}
                                lineColor={'#B4B4B4'}
                                lineBorderRadius={'4px'}
                              >
                                                  {paymentModal()}

                                {renderTree(null)}
                              </Tree>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
          
        };
          

        };


        const redirect = ()=>(

            history.push("/")

        );

        return (
          <div>
           {!currentUser ?  redirect() : loggedIn()}
          </div>
        );
            
            
      };
      
      export default Workspace;